// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__If3wQ","imageWrapper":"Hero_imageWrapper__D11xK","content":"Hero_content__s_RqY","paragraph":"Hero_paragraph__g8j_5","author":"Hero_author__j7Cxt"};